import useInterval from '@common/application/hooks/useInterval/useInterval';
import { useSession } from 'next-auth/react';
import { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface SessionTimeProps {}

function SessionTime(props: SessionTimeProps) {
  const intl = useIntl();
  const [sessionTimeLeft, setSessionTimeLeft] = useState<null | number>(0);
  const { data: session } = useSession();

  const formatTime = useCallback(() => {
    const now = new Date();
    const expires = new Date(session?.expires ?? Date.now());
    const ttl = Math.max(0, expires.valueOf() - now.valueOf());
    if (!ttl) {
      return intl.formatMessage({ defaultMessage: 'Session Expired', description: 'Log in has expired and user must log in again' });
    }
    const dayMultiplier = 1000 * 60 * 60 * 24;
    const hourMultiplier = 1000 * 60 * 60;
    const minuteMultiplier = 1000 * 60;
    const days = Math.floor(ttl / dayMultiplier);
    // const days = Math.floor(ttl / 86400000);
    const _ttl = ttl % dayMultiplier;
    const hours = Math.floor(_ttl / hourMultiplier);
    const __ttl = ttl % hourMultiplier;
    const minutes = Math.floor(__ttl / minuteMultiplier);
    const seconds = Math.floor((__ttl % minuteMultiplier) / 1000);

    const daysString = days ? `${days} ${intl.formatMessage({ defaultMessage: 'days' })}` : '';
    const hoursString = `${hours} ${intl.formatMessage({ defaultMessage: 'hours' })}`;
    const secondsString = `${seconds} ${intl.formatMessage({ defaultMessage: 'secs', description: 'abbreviated form of "seconds"' })}`;
    const minutesString = `${minutes} ${intl.formatMessage({ defaultMessage: 'mins', description: 'abbreviated form of "minutes"' })}`;
    return ttl === 0 ? '' : `${daysString} ${hoursString} ${minutesString} ${secondsString}`;
  }, [intl, session?.expires]);

  useInterval(() => {
    const now = new Date();
    const expires = new Date(session?.expires ?? Date.now());
    const ttl = Math.max(0, expires.valueOf() - now.valueOf());
    setSessionTimeLeft(ttl ? ttl : null);
  }, 1000);

  return (
    <>
      <FormattedMessage defaultMessage="Session Expires In: " description="User menu session expires in timer label" /> {formatTime()}
    </>
  );
}

export default SessionTime;
